import { Avatar, type AvatarSize } from './Avatar'
import { cn } from './cn'

export interface AvatarStackUser {
  id?: string | number | null
  name?: string | null
  src?: string | null
}

export interface AvatarStackProps {
  users: AvatarStackUser[]
  /** Max avatars before the "+k" bubble. */
  max?: number
  /** Total count when it is larger than users.length (for example 2,314 members). */
  total?: number
  size?: AvatarSize | number
  className?: string
  label?: string
}

/** Overlapping facepile (overlap 6px, surface rings) with a "+k" bubble. */
export function AvatarStack({ users, max = 5, total, size = 28, className, label }: AvatarStackProps) {
  const shown = users.slice(0, max)
  const count = Math.max(total ?? users.length, users.length)
  const extra = count - shown.length
  const extraLabel = extra > 999 ? `+${Math.floor(extra / 1000)}k` : `+${extra}`
  return (
    <div className={cn('flex items-center', className)} role="group" aria-label={label ?? `${count} people`}>
      {shown.map((u, i) => (
        <Avatar
          key={u.id ?? `${u.name}-${i}`}
          id={u.id}
          name={u.name}
          src={u.src}
          size={size}
          ring
          className={i === 0 ? undefined : '-ml-1.5'}
          style={{ zIndex: shown.length - i }}
        />
      ))}
      {extra > 0 && (
        <span
          className="-ml-1.5 inline-flex shrink-0 items-center justify-center rounded-full bg-surface-2 px-1 text-[11px] font-bold text-muted ring-2 ring-surface tabular-nums"
          style={{ minWidth: size, height: size }}
          aria-hidden="true"
        >
          {extraLabel}
        </span>
      )}
    </div>
  )
}
